const makeInitials = (name) => {
  if (!name) return;
  const tokens = name.split(" ");
  const initials = tokens[0][0] + (tokens[tokens.length - 1][0] || "");
  return initials;
};

export default makeInitials;
